/**
 * Clipboard text = exact system + user strings sent to the model (first generate call)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { GenerationPromptPreview } from '../types/campaign-texts.types';

export function formatGenerationPromptForClipboard(p: GenerationPromptPreview): string {
  const sys = p.systemPrompt.trim();
  const usr = p.userPrompt.trim();
  if (!sys) return usr;
  if (!usr) return sys;
  return `${sys}\n\n${usr}`;
}
